import React from 'react'
import geoUrlData from './static/map.json'
import { ComposableMap, Geographies, Geography, Marker, Text } from 'react-simple-maps'

const geoUrl = geoUrlData

export default function Map({ locations }) {
    return (
        <ComposableMap>
            <Geographies geography={geoUrl}>
                {({ geographies }) =>
                    geographies.map((geo) => (
                        <Geography
                            style={{
                                default: { outline: 'none' },
                                hover: { outline: 'none' },
                                pressed: { outline: 'none' },
                            }}
                            key={geo.rsmKey}
                            geography={geo}
                            fill={'#bfbfbd'}
                        />
                    ))
                }
            </Geographies>
            {locations?.length > 0 &&
                locations.map(({ longitude, latitude }, index) => {
                    return (
                        <Marker key={index} style coordinates={[longitude, latitude]}>
                            <circle className="animate-ping" r={7} fill="white" />
                            <circle r={6} fill="#0097c2" />
                        </Marker>
                    )
                })}
        </ComposableMap>
    )
}
